import customizeScrollbar from "customsb";
import React, { useEffect, useState } from "react";
import Navbar  from "../navbar/navbar";
import { api } from '../../services/api';
import { vhostV1 } from '../funcoes';
import './cadastro.css'
import { Link, Navigate } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import BuscaVazaia from "../components/buscavazia/buscaVazia";
import ModalCadastroEntregador from "../cadastro/novoCadastroMotoqueiro";

function CadastroMotoqueiro() {
  const [navegar, setNavegar] = useState(false);

  const [cadastros, setCadastros] = useState([
    {
      CODIGO: 1,
      NOME: "Motoqueiro",
      TELEFONE: "07012345678",
    },
  ]);

  const [texto, setTexto] = useState("");
  const [busca, setBusca] = useState("");
  const [sResult, setSresult] = useState(1);

  // 🔹 CONTROLE DO MODAL
  const [openModal, setOpenModal] = useState(false);
  const [entregadorSelecionado, setEntregadorSelecionado] = useState(null);

  useEffect(() => {
    customizeScrollbar({
      scrollbarWidth: "10px",
      trackBackground: "#333",
      thumbBackground:
        "linear-gradient(178.8deg, #ffa066 47.41%, #ff9666 65.18%, #ff783a 90.84%)",
      thumbBorderRadius: "10px",
    });
  }, []);

  return (
    <div>
      <Navbar />

      <div className="container-fluid titulo offset-lg-1 col-lg-10">
        <h1>Cadastro Motoqueiro</h1>
        <hr />

        {/* 🔹 AÇÕES */}
        <div className="row">
          <div className="col-4">
            <button
              id="botao-cadastro"
              className="btn btn-primary btn-cli"
              type="button"
              onClick={() => {
                setEntregadorSelecionado(null); // novo cadastro
                setOpenModal(true);
              }}
            >
              <i className="bi bi-plus-circle-fill"></i> Cadastrar
            </button>

            <button
              id="botao-cadastro"
              className="btn btn-danger btn-cli"
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
            >
              <i className="bi bi-printer-fill"></i> Relatório
            </button>
          </div>

          {/* 🔹 PESQUISA */}
          <div className="col-8">
            <div className="input-group mb-3">
              <input
                onChange={(e) => setTexto(e.target.value)}
                type="text"
                className="form-control"
                placeholder="Digite sua pesquisa"
              />
              <button
                onClick={() => setBusca(texto)}
                className="btn btn-primary"
                type="button"
              >
                <i className="bi bi-search"></i> Pesquisar
              </button>
            </div>
          </div>
        </div>

        {/* 🔹 LISTAGEM */}
        {sResult === 1 ? (
          <>
            <table
              id="table-cliente"
              className="table table-hover table-striped"
            >
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Nome</th>
                  <th>Telefone</th>
                  <th>Ações</th>
                </tr>
              </thead>

              <tbody className="table-group-divider">
                {cadastros.map((cadastro) => (
                  <tr key={cadastro.CODIGO}>
                    <td>{cadastro.CODIGO}</td>
                    <td>{cadastro.NOME}</td>
                    <td>{cadastro.TELEFONE}</td>
                    <td>
                      <i
                        className="bi bi-pen-fill"
                        style={{ cursor: "pointer", marginRight: 10 }}
                        onClick={() => {
                          setEntregadorSelecionado({
                            codigo: cadastro.CODIGO,
                            nome: cadastro.NOME,
                            numero: cadastro.TELEFONE,
                          });
                          setOpenModal(true);
                        }}  
                      ></i>

                      <i className="bi bi-trash-fill red"></i>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* 🔹 PAGINAÇÃO */}
            <nav>
              <ul className="pagination">
                <li className="page-item">
                  <a className="page-link" href="#">
                    Anterior
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="#">
                    1
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="#">
                    Próximo
                  </a>
                </li>
              </ul>
            </nav>
          </>
        ) : (
          <BuscaVazaia />
        )}

        {navegar ? <Navigate to="/app/cadastro/c" /> : null}
      </div>

      {/* 🔹 MODAL MUI DE CADASTRO / EDIÇÃO */}
      <ModalCadastroEntregador
        open={openModal}
        onClose={() => setOpenModal(false)}
        entregadorSelecionado={entregadorSelecionado}
      />
    </div>
  );
}

export default CadastroMotoqueiro;
